import { render, staticRenderFns } from "./WonderTopicTable.vue?vue&type=template&id=3ded4ccd&scoped=true"
import script from "./WonderTopicTable.vue?vue&type=script&lang=js"
export * from "./WonderTopicTable.vue?vue&type=script&lang=js"
import style0 from "./WonderTopicTable.vue?vue&type=style&index=0&id=3ded4ccd&prod&scoped=true&lang=css"
import style1 from "./WonderTopicTable.vue?vue&type=style&index=1&id=3ded4ccd&prod&lang=css"
import style2 from "./WonderTopicTable.vue?vue&type=style&index=2&id=3ded4ccd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ded4ccd",
  null
  
)

export default component.exports